/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkBusinessdivision } from '../models/work-businessdivision';
import { WorkCreateBusinessdivisionDto } from '../models/work-create-businessdivision-dto';
import { WorkDropdownOptionDto } from '../models/work-dropdown-option-dto';
import { WorkPaginatedDocumented } from '../models/work-paginated-documented';
import { WorkSuccessDto } from '../models/work-success-dto';
import { WorkUpdateBusinessdivisionDto } from '../models/work-update-businessdivision-dto';

@Injectable({ providedIn: 'root' })
export class WorkBusinessdivisionsV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `businessdivisionsV2ControllerGetAllDropdownOptions()` */
  static readonly BusinessdivisionsV2ControllerGetAllDropdownOptionsPath = '/v2/businessdivisions/dropdown-options';

  /**
   * Required permissions: users:read, users:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `businessdivisionsV2ControllerGetAllDropdownOptions()` instead.
   *
   * This method doesn't expect any request body.
   */
  businessdivisionsV2ControllerGetAllDropdownOptions$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkDropdownOptionDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkBusinessdivisionsV2Service.BusinessdivisionsV2ControllerGetAllDropdownOptionsPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkDropdownOptionDto>>;
      })
    );
  }

  /**
   * Required permissions: users:read, users:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `businessdivisionsV2ControllerGetAllDropdownOptions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  businessdivisionsV2ControllerGetAllDropdownOptions(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkDropdownOptionDto>> {
    return this.businessdivisionsV2ControllerGetAllDropdownOptions$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkDropdownOptionDto>>): Array<WorkDropdownOptionDto> => r.body)
    );
  }

  /** Path part for operation `businessdivisionsV2ControllerFindAllPaginated()` */
  static readonly BusinessdivisionsV2ControllerFindAllPaginatedPath = '/v2/businessdivisions/paginated';

  /**
   * Required permissions: users:read, users:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `businessdivisionsV2ControllerFindAllPaginated()` instead.
   *
   * This method doesn't expect any request body.
   */
  businessdivisionsV2ControllerFindAllPaginated$Response(
    params?: {
      withSupervisor?: boolean;

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by active query param.
     *           <p>
     *              <b>Format: </b> filter.active={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.active=$not:$like:John Doe&filter.active=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.active'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> name:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>name</li>
     * <li>shortname</li>
     * <li>active</li></ul>
     */
      sortBy?: Array<'name:ASC' | 'name:DESC' | 'shortname:ASC' | 'shortname:DESC' | 'active:ASC' | 'active:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> name,shortname
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>name</li>
     * <li>shortname</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkBusinessdivision>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'active'?: (string | Array<string>);
};
};
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkBusinessdivisionsV2Service.BusinessdivisionsV2ControllerFindAllPaginatedPath, 'get');
    if (params) {
      rb.query('withSupervisor', params.withSupervisor, {});
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.query('filter.active', params['filter.active'], {});
      rb.query('sortBy', params.sortBy, {});
      rb.query('search', params.search, {});
      rb.query('searchBy', params.searchBy, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPaginatedDocumented & {
        'data'?: Array<WorkBusinessdivision>;
        'meta'?: {
        'select'?: Array<string>;
        'filter'?: {
        'active'?: (string | Array<string>);
        };
        };
        }>;
      })
    );
  }

  /**
   * Required permissions: users:read, users:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `businessdivisionsV2ControllerFindAllPaginated$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  businessdivisionsV2ControllerFindAllPaginated(
    params?: {
      withSupervisor?: boolean;

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by active query param.
     *           <p>
     *              <b>Format: </b> filter.active={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.active=$not:$like:John Doe&filter.active=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.active'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> name:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>name</li>
     * <li>shortname</li>
     * <li>active</li></ul>
     */
      sortBy?: Array<'name:ASC' | 'name:DESC' | 'shortname:ASC' | 'shortname:DESC' | 'active:ASC' | 'active:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> name,shortname
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>name</li>
     * <li>shortname</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<WorkPaginatedDocumented & {
'data'?: Array<WorkBusinessdivision>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'active'?: (string | Array<string>);
};
};
}> {
    return this.businessdivisionsV2ControllerFindAllPaginated$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkBusinessdivision>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'active'?: (string | Array<string>);
};
};
}>): WorkPaginatedDocumented & {
'data'?: Array<WorkBusinessdivision>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'active'?: (string | Array<string>);
};
};
} => r.body)
    );
  }

  /** Path part for operation `businessdivisionsV2ControllerFindById()` */
  static readonly BusinessdivisionsV2ControllerFindByIdPath = '/v2/businessdivisions/{id}';

  /**
   * Required permissions: users:read, users:read, users:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `businessdivisionsV2ControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  businessdivisionsV2ControllerFindById$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkBusinessdivision>> {
    const rb = new RequestBuilder(this.rootUrl, WorkBusinessdivisionsV2Service.BusinessdivisionsV2ControllerFindByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkBusinessdivision>;
      })
    );
  }

  /**
   * Required permissions: users:read, users:read, users:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `businessdivisionsV2ControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  businessdivisionsV2ControllerFindById(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkBusinessdivision> {
    return this.businessdivisionsV2ControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkBusinessdivision>): WorkBusinessdivision => r.body)
    );
  }

  /** Path part for operation `businessdivisionsV2ControllerDelete()` */
  static readonly BusinessdivisionsV2ControllerDeletePath = '/v2/businessdivisions/{id}';

  /**
   * Required permissions: users:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `businessdivisionsV2ControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  businessdivisionsV2ControllerDelete$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkBusinessdivisionsV2Service.BusinessdivisionsV2ControllerDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * Required permissions: users:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `businessdivisionsV2ControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  businessdivisionsV2ControllerDelete(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.businessdivisionsV2ControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

  /** Path part for operation `businessdivisionsV2ControllerUpdate()` */
  static readonly BusinessdivisionsV2ControllerUpdatePath = '/v2/businessdivisions/{id}';

  /**
   * Required permissions: users:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `businessdivisionsV2ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  businessdivisionsV2ControllerUpdate$Response(
    params: {
      id: number;
      body: WorkUpdateBusinessdivisionDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkBusinessdivisionsV2Service.BusinessdivisionsV2ControllerUpdatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * Required permissions: users:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `businessdivisionsV2ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  businessdivisionsV2ControllerUpdate(
    params: {
      id: number;
      body: WorkUpdateBusinessdivisionDto
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.businessdivisionsV2ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

  /** Path part for operation `businessdivisionsV2ControllerCreate()` */
  static readonly BusinessdivisionsV2ControllerCreatePath = '/v2/businessdivisions';

  /**
   * Required permissions: users:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `businessdivisionsV2ControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  businessdivisionsV2ControllerCreate$Response(
    params: {
      body: WorkCreateBusinessdivisionDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkBusinessdivision>> {
    const rb = new RequestBuilder(this.rootUrl, WorkBusinessdivisionsV2Service.BusinessdivisionsV2ControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkBusinessdivision>;
      })
    );
  }

  /**
   * Required permissions: users:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `businessdivisionsV2ControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  businessdivisionsV2ControllerCreate(
    params: {
      body: WorkCreateBusinessdivisionDto
    },
    context?: HttpContext
  ): Observable<WorkBusinessdivision> {
    return this.businessdivisionsV2ControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkBusinessdivision>): WorkBusinessdivision => r.body)
    );
  }

}
